<template>
  <div v-if="question">
    <div class="p-3 px-5 bg-gray-toeic" v-if="SubDirection">
      <p class="text-left mb-0 text-lg max-w-3xl mx-auto"  v-html="SubDirection.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></p>
    </div>
    <div class="p-3 max-w-2xl mx-auto" v-if="question.ImageUrl">
      <img :src="question.ImageUrl" class="object-contain w-100">
    </div>
    <div class="p-3 px-5" v-if="question.Title">
      <p class="text-center mb-0 text-lg max-w-3xl mx-auto" >{{ question.Title }}</p>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Part1DescribeImage',

    data () {
      return {
      }
    },
    props: {
      question: {
        type: Object
      },
      index: {
        type: Number
      },
      total: {
        type: Number
      },
      answer: {
        type: Array
      },
      SubDirection: {
        type: String
      }
    },

    methods: {
      finishPart1 () {
        this.$emit('go-to-part2', this.answers)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .bg-gray-toeic {
    background-color: #C0C0C0;
  }
</style>
